import Grid from '@mui/material/Grid2';
import { TrendyolSettings } from './TrendyolSettings';
import { HepsiburadaSettings } from './HepsiburadaSettings';
import { BoynerSettings } from './BoynerSettings';
import { N11Settings } from './N11Settings';
import { PazaramaSettings } from './PazaramaSettings';

export const PartnerSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <TrendyolSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <HepsiburadaSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <BoynerSettings />
      </Grid>
      {/* <Grid size={{ xs: 12, lg: 6 }}> */}
      {/*  <CiceksepetiSettings /> */}
      {/* </Grid> */}
      <Grid size={{ xs: 12, lg: 6 }}>
        <N11Settings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <PazaramaSettings />
      </Grid>
    </Grid>
  );
};
